<template>
  <div class="mobile-2__mobile-hero">
    <img src="../.././public/misc/sundowner--1--mobile.png">
  </div>
  <div class="recipes-2">
    <img class="recipes-2__img--ingredient recipes-2__img--ingredient--1" src="../.././public/misc/mint.png">
    <img class="recipes-2__img--ingredient recipes-2__img--ingredient--2" src="../.././public/misc/orange.png">
    <img class="recipes-2__img--ingredient recipes-2__img--ingredient--3" src="../.././public/misc/raspberry-1.png">
    <img class="recipes-2__img--ingredient recipes-2__img--ingredient--4" src="../.././public/misc/raspberry-2.png">
    <div class="recipes-2__col recipes-2__col--1 pt--50">
      
      <div class="recipes-2__h1">
        PIMM’S

      </div>
      <div class="recipes-2__h2">
        SUNDOWNER SPRITZ
      </div>
      <div class="recipes-2__ingredients">
     
        <div class="recipes-2__ingredient">
          <span class="recipe-1__a cswidget" data-product-sku="768819, 764611, 764651" data-asset-id="2304">1 PART (50ML) PIMM’S SUNDOWNER</span>
        </div>
        <div class="recipes-2__ingredient">
          1 PART (50ML) PROSECCO
        </div>
        <div class="recipes-2__ingredient">
          1 PART (50ML) SODA 
        </div>
        <div class="recipes-2__ingredient">
          GARNISH WITH FRESH RASPBERRIES AND LOTS OF&nbsp;ICE
        </div>
      </div>
      <div class="recipes-2__method">
         (1.5 UNITS PER SERVE IF PROSECCO IS 11%&nbsp;ABV)
      </div>
      <div class="recipes-2__cta cswidget" data-product-sku="768819, 764651, 764611" data-asset-id="2304" data-action="csWidgetOpen">
        BUY PIMM’S SUNDOWNER
      </div>
      <div class="recipes-2__price">
        FROM £<span class="recipes-2__from"></span>
      </div>
    </div>
    <div class="recipes-2__col recipes-2__col--2">
      <img class="recipes-2__img--serve" src="../.././public/misc/serve--sundowner.png">
      <img class="recipes-2__img--1" src="../.././public/misc/sundowner--1.png">
      <img class="recipes-2__img--2" src="../.././public/misc/sundowner--2.png">
    </div>
    
  </div>
  <div class="recipes-2__drinkaware">
    <img src="../.././public/misc/drinkaware.png" width="200">
  </div>
  <div class="stripes">
    <div class="stripe"></div>
    <div class="stripe"></div>
    <div class="stripe"></div>
  </div>
</template>
<script setup>
import gsap from 'gsap';
import dataModel from "../js/model.js";
const props = defineProps({
  brandExperience: {
    type: String,
    default: "1",
  }
});

$(document).ready(function() {
  $('.recipes-2__from').html(dataModel[2].retailers[1].price)
  var tlOrange = gsap.timeline({repeat: -1});
  tlOrange.to('.recipes-2__img--ingredient--2', {
    duration: 3,
    rotate: 15,
    ease: 'in'
  })
  .to('.recipes-2__img--ingredient--2', {
    duration: 2,
    rotate: 0,
    ease: 'out'
  })
  var tlRasp_1 = gsap.timeline({repeat: -1});
  tlRasp_1.to('.recipes-2__img--ingredient--3', {
    duration: 1,
    rotate: 15,
    ease: 'in'
  })
  .to('.recipes-2__img--ingredient--3', {
    duration: 3.3,
    rotate: 0,
    ease: 'out'
  })
  var tlRasp_2 = gsap.timeline({repeat: -1});
  tlRasp_2.to('.recipes-2__img--ingredient--4', {
    duration: 2,
    rotate: -15,
    y: 40,
    ease: 'Power3.in'
  })
  .to('.recipes-2__img--ingredient--4', {
    duration: 2,
    rotate: 0,
    y: 0,
    ease: 'Power3.in'
  })

  
  
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.recipes-2 {
  @include flexbox();
  @include align-items(flex-start);
  @include justify-content(center);
  margin: auto;
  max-width: 960px;
  position: relative;
  width: 100%;
  z-index: 1;
  @media screen and(max-width: 768px) {
    padding-bottom: 200px;
  }

}
.recipes-2__col {
  @include flexbox();
  @include align-items(center);
  @include justify-content(flex-start);
  @include flex-direction(column);
  height: 100%;
  position: relative;
  @media screen and(max-width: 768px) {
    max-width: none;
  }
}
.recipes-2__col--1 {
    width: 100%;
    max-width: 320px;
  @media screen and(max-width: 768px) {
    @include align-self(flex-start);
    padding-left: 20px;
    text-align: left;
    width: 200px;
   
    & > div {
      width: 100%;
    }
  }
}
.recipes-2__col--2 {
  @include flex(1);
}
.recipes-2__h1 {
  color: $color--red;
  font-weight: 700;
  font-size: 36px;
  line-height: 30px;
}
.recipes-2__h2 {
  color: $color--gold;
  font-weight: 700;
  font-size: 26px;
  line-height: 30px;
  @media screen and(max-width: 768px) {
    font-size: 20px;
    line-height: 24px;
  }
}
.recipes-2__ingredient {
  color: #222222;
  font-size: 18px;
  line-height: 22px;
  &:first-child {
    margin-top: 30px;
  }
  &:not(:first-child) {
    margin-top: 5px;
  }
  @media screen and(max-width: 768px) {
    font-size: 16px;
    line-height: 20px;
  }
  
}
.recipes-2__method {
  color: #222222;
  font-size: 18px;
  line-height: 22px;
  margin-top: 30px;
  @media screen and(max-width: 768px) {
    font-size: 16px;
    line-height: 20px;
  }
  
}
.recipes-2__cta {
  background: $color--red;
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 1px;
  margin: 30px 0px 15px 0px;
  padding: 15px;
  text-transform: uppercase;
  text-align: center;
  width: 180px;
  @media screen and(max-width: 767px) {
    font-size: 20px;
    line-height: 20px;
  }
}
.recipe-1__a {
  color: $color--gold;
  text-decoration: underline;
}
.recipes-2__price {
  font-size: 16px;
  color: $color--red;
}
.recipes-2__col--2 {
  height: 550px;
}
.recipes-2__img--serve {
  bottom: 0px;
  position: absolute;
  left: 20px;
  width: 200px;
  z-index: 100;
  @media screen and(max-width: 768px) {
    left: 50px;
    top: 50px;
    width: 150px;
  }
}
.recipes-2__img--1 {
  bottom: 100px;
  left: 120px;
  position: absolute;
  width: 280px;
   @media screen and(max-width: 768px) {
    display: none
  }
}
.recipes-2__img--2 {
  bottom: 20px;
  left: 410px;
  position: absolute;
  width: 280px;
   @media screen and(max-width: 768px) {
    display: none
  }
}
.mobile-2__mobile-hero {
  display: none;
  position: relative;
  @media screen and(max-width: 768px) {
    display: block;
    width: 100%;
  }
  & > img {
    width: 100%;
  }
}
.recipes-2__drinkaware {
  padding-top: 50px;
  @media screen and(max-width: 768px) {
    padding-top: 0px;
    margin-bottom: 50px;
  }
}

.stripes {
  width: 100%;
  @media screen and(max-width: 768px) {
    margin-top: -50px;
    padding-bottom: 0px;
  }
}
.stripe {
  background: $color--red;
  height: 7px;
  margin-top: 7px;
  width: 100%;
}
.recipes-2__img--ingredient {
  position: absolute;

  &--1 {
    right: -200px;
    top:-130px;
    width: 400px;
    z-index: 1;
    @media screen and(max-width: 768px) {
      display: none;
    }
  }

  &--2 {
    left: -300px;
    top:-130px;
    width: 400px;
    z-index: 1;
    @media screen and(max-width: 768px) {
      left: -100px;
      top: -380px;
      width: 340px;
    }
  }
  &--3 {
    left: -100px;
    bottom:-130px;
    width: 200px;
    z-index: 1;
    @media screen and(max-width: 768px) {
      left: 30px;
      bottom: 50px;
      width: 250px;
    }
  }
  &--4 {
    left: calc(50% + 100px);
    top:50px;
    width: 150px;
    z-index: 1;
    @media screen and(max-width: 768px) {
      display: none;
    }
  }
}
</style>